<template>
  <va-navbar class="app-layout-navbar glass-panel">
    <template #left>
      <div class="left">
        <va-icon-menu-collapsed
          :class="{ 'x-flip': isSidebarMinimized }"
          class="va-navbar__item"
          :color="colors.links"
          @click="isSidebarMinimized = !isSidebarMinimized"
        />
        <!-- <img src="@/assets/logo/logo600x600.jpg"/> -->
        <router-link to="/">
          <!-- <vuestic-logo class="logo" /> -->
            <img v-show="switchValue == 'dark'" src="../../assests/logo/logo_white_1.png" width="230"/>
            <img v-show="switchValue == 'light'" src="../../assests/logo/logo_black_1.png" width="230"/>
        </router-link>
      </div>
    </template>
    <template #center>
      <div class="app-navbar-center">
        <!-- <span class="app-navbar-center__text mr-2">{{ t('navbar.messageUs') }}</span>
        <a   //////src="~/@/assets/logo/MT_logo_white.png"
          class="app-navbar-center__mail mr-2"
          href="mailto:hello@epicmax.co"
          target="_blank"
          :style="{ color: colors.primary }"
        >
          hello@epicmax.co
        </a> -->
        <!-- <p class="theme__title">Dark mode:  </p> -->
        
        <!-- <va-button
          href="https://github.com/epicmaxco/vuestic-admin"
          color="#000000"
          class="app-navbar-center__github-button"
          icon="github"
          target="_blank"
        > -->
          <!-- {{ t('navbar.repository') }} -->
        <!-- </va-button> -->
      </div>
    </template>
    <template #right>
      <VaSwitch v-model="switchValue"
          class="theme__btn"
          true-value="dark"
          false-value="light"
          size="small" 
          true-inner-label="Светлая"
          false-inner-label="Тёмная"
          color="pimary"
          off-color="backgroundBorder"
          />

        <!-- <va-button
          v-if="!isAdmin"
          icon="login"
          color="primary"
          class="ml-2"
          @click="showLoginModal = true">
          Вход
        </va-button> -->

        <va-button
          v-if="isAdmin"
          icon="logout"
          color="danger"
          class="ml-2"
          @click="logout">
          Выйти
        </va-button>
<!-- 
        <va-modal v-model="showLoginModal" title="Вход администратора" ok-text="Войти" @ok="login">
          <va-input v-model="username" label="Имя пользователя" />
          <va-input v-model="password" label="Пароль" type="password" />
          <va-alert
            v-if="error"
            color="danger"
            class="mt-2"
            dense>
            {{ error }}
          </va-alert>
      </va-modal> -->
      <!-- <app-navbar-actions class="app-navbar__actions md5 lg4" :user-name="userName" /> -->
    </template>
  </va-navbar>
</template>

<script setup>
  import { computed, ref, watch, onMounted } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useGlobalStore } from '../../stores/global-store'
  import { useI18n } from 'vue-i18n'
  import { useColors } from 'vuestic-ui'
  import VuesticLogo from '../VuesticLogo.vue'
  import VaIconMenuCollapsed from '../icons/VaIconMenuCollapsed.vue'
  import AppNavbarActions from './components/AppNavbarActions.vue'
  import axios from 'axios'
  // import { storeToRefs } from 'pinia'
  // const { isAdmin } = storeToRefs(GlobalStore)
  const GlobalStore = useGlobalStore()
  const { t } = useI18n()

  const { isSidebarMinimized,isAdmin}= storeToRefs(GlobalStore)

  // const { getColors } = useColors()
  // const colors = computed(() => getColors())

  const { applyPreset, currentPresetName, colors } = useColors();

  const switchValue = computed({
  get() { return currentPresetName.value },
  set(value) { localStorage.setItem('mainTheme', value), applyPreset(value) }
  })

  function initializeTheme() {
  const savedTheme = localStorage.getItem('mainTheme');

  if (!savedTheme) {
    const defaultTheme = 'light';
    applyPreset(defaultTheme);
    localStorage.setItem('mainTheme', defaultTheme);
  } else {
    applyPreset(savedTheme);
  }
}
 onMounted(initializeTheme)
  

// admin login modal
const showLoginModal = ref(false)
const username = ref('')
const password = ref('')
const error = ref('')

const login = async () => {
  try {
    const res = await axios.post('/api/admin-login', {
      username: username.value,
      password: password.value,
    })

    if (res.data.success) {
      GlobalStore.loginAsAdmin()
      showLoginModal.value = false
      username.value = ''
      password.value = ''
      error.value = ''
    } else {
      error.value = 'Неверное имя пользователя или пароль'
    }
  } catch {
    error.value = 'Ошибка входа. Проверьте соединение.'
  }
}

const logout = () => {
  GlobalStore.logoutAdmin()
}

const handleKeydown = (e) => {
  if (e.key === 'Enter' && showLoginModal.value) {
    login()
  }
}

watch(showLoginModal, (isOpen) => {
  if (isOpen) {
    window.addEventListener('keydown', handleKeydown)
  } else {
    window.removeEventListener('keydown', handleKeydown)
  }
})


</script>

<style lang="scss" scoped>
  .va-navbar {
    box-shadow: var(--va-box-shadow);
    z-index: 2;

    @media screen and (max-width: 950px) {
      .left {
        width: 100%;
      }

      .app-navbar__actions {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .left {
    display: flex;
    align-items: center;

    & > * {
      margin-right: 1.5rem;
    }

    & > *:last-child {
      margin-right: 0;
    }
  }

  .x-flip {
    transform: scaleX(-100%);
  }

  .app-navbar-center {
    display: flex;
    align-items: center;

    @media screen and (max-width: 1200px) {
      &__github-button {
        display: none;
      }
    }

    @media screen and (max-width: 950px) {
      &__text {
        display: none;
      }
    }
  }

  .theme__btn {
    margin: 5px 10px 5px 0px;
  }
</style>
